import { PlatformUtility } from 'utility-ts-platform';

export class HoldModalController {
  private isMobile: boolean = false;

  constructor(private ngHoldModalService: HoldModalService) {
    this.isMobile = PlatformUtility.isMobile();
  }

  closeModal(): void {
    this.ngHoldModalService.isOpen = false;
  }
}

export class HoldModalService {
  private _isOpen: boolean = false;

  get isOpen(): boolean {
    return this._isOpen;
  }

  set isOpen(isOpen: boolean) {
    this._isOpen = isOpen;
  }
}

export class HoldModalComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-holds/src/hold_modal/hold_explanation_modal.html';
  public controller: any = HoldModalController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/hold_modal/hold_explanation_modal.ts